import { RightSidebarHeader } from "../../../../components/Layout/RightSidebarWidget";
import { BookOpenText, SubtitlesSlash, TextAa } from "@phosphor-icons/react";
import React, { useState } from "react";
import { Button, Flex, MenuItem, MenuList, Text, Textarea, useToast } from "@chakra-ui/react";
import { MultiSelect } from "../../../../components";
import { useRightSidebar } from "../../../../context/RightSidebarContext";
import { issbKeys, useExcludeAnswer, useSaveAnswer } from "../../../../hooks/query";
import { hideAppSpinner, showAppSpinner } from "../../../../context/Store/slices/appSpinnerSlice";
import { showErrorToast } from "../../../../utils";
import { useDispatch } from "react-redux";
import { useQueryClient } from "react-query";

const EXCLUDE_OPTIONS = [
  { label: "Disclosed elsewhere", value: "Disclosed elsewhere" },
  { label: "Not applicable", value: "Not applicable" },
  { label: "Duplicate", value: "Duplicate" },
];

/**
 *
 * @param {Object} props
 * @param {Object} props.questionData - Question data Can be null while loading.
 * @param {string[]?} props.questionIds - Array of question ids for BulkActions
 * @param {boolean} props.isExcluded - current state
 * @param {Function} props.setIsExcluded - Function to set the excluded state
 * @returns
 */
const AnswerExclusionCard = ({ questionData, questionIds, isExcluded, setIsExcluded }) => {
  const { doClose } = useRightSidebar();
  const toast = useToast();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [selectedJustification, setSelectedJustification] = useState(null);
  const [comment, setComment] = useState("");

  const { mutate: excludeAnswer } = useExcludeAnswer({
    onMutate: () => dispatch(showAppSpinner()),
    onError: (err) => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    onSettled: () => {
      dispatch(hideAppSpinner());
      doClose();
    },
    onSuccess: () => {
      setIsExcluded(!isExcluded);
      // keep this to auto-refresh the question data, so that it will reflect latest changes (stages, etc)
      queryClient.invalidateQueries(issbKeys.answer());
    },
  });

  const handleExclude = () => {
    if (!comment.trim() || (!isExcluded && !selectedJustification)) {
      toast({
        title: "Error",
        description: isExcluded ? "Comment is required." : "Justification and comment are required.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const dataToSubmit = {
      questionIds: questionIds?.length ? questionIds : [questionData.id],
      justification: selectedJustification ? selectedJustification.value : null,
      comment: comment,
      exclude: !isExcluded,
    };

    excludeAnswer(dataToSubmit);
  };

  return (
    <Flex gap={6} direction="column" mx={2}>
      <RightSidebarHeader Icon={SubtitlesSlash}>
        {isExcluded ? "Re-instate excluded requirement" : "Exclude requirement"}
      </RightSidebarHeader>
      {!isExcluded ? (
        <Text>
          You might want to exclude this requirement if you believe it is not applicable to your organisation or you
          where you have provided a compliant disclosure against another requirement. Please ensure you have read all
          the guidance before deciding to exclude. You must provide a justification for exclusion.
        </Text>
      ) : (
        <Text>
          This requirements was previously marked for exclusion. Re-instating it will require a specific response and
          approval. You may wish to adda comment as to why this requirement is now applicable.
        </Text>
      )}

      {!isExcluded && (
        <Flex direction="column" gap={2}>
          <Text fontSize="heading.s" mb={2} fontWeight="bold">
            Justification for exclusion
          </Text>
          <MultiSelect
            isMulti={false}
            options={EXCLUDE_OPTIONS}
            onChange={(selected) => setSelectedJustification(selected)}
          />
        </Flex>
      )}
      <Flex direction="column" gap={2}>
        <Text fontSize="heading.s" mb={2} fontWeight="bold">
          Add a comment
        </Text>
        <Textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Comment ..." />
      </Flex>

      <Flex direction="column" gap={2}>
        <Button
          variant="primary"
          onClick={() => {
            handleExclude();
          }}
        >
          Save
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            doClose();
          }}
        >
          Cancel
        </Button>
      </Flex>
    </Flex>
  );
};

export default AnswerExclusionCard;
